/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/WinAnimators/ButterflyWinAnimator',['pixi',
        'proton',
        'absolute',
        'absolute/particleemitter',
        'util/Random',
        'CardUI/WinAnimators/BaseWinAnimator',
        'Arkadium/GameEngine/Scenes/Nodes/SceneNode',
        'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
        'Arkadium/GameEngine/Maths/Vector2',
        'Arkadium/GameEngine/Maths/Bezier2D',
        'Arkadium/GameEngine/Tween/Tween',
        'Arkadium/GameEngine/Core/EngineManagers',
        'absolute/audiomanager'
    ],
    function (PIXI, Proton, Absolute, ParticleEmitter, Random, BaseWinAnimator, SceneNode, SpriteNode, Vector2, Bezier2D, Tween, EngineManagers, AudioManager) {
        "use strict";

        var AnimationStateEnum =
        {
            None: 0,
            Fogging: 1,
            PilesGlow: 2,
            SpawnCards: 3,
            Done: 4
        };

        var ButterflyWinAnimator = function (supplyView) {
            this.initButterflyWinAnimator(supplyView);
        };

        ButterflyWinAnimator.prototype = Object.create(BaseWinAnimator.prototype);
        ButterflyWinAnimator.prototype.constructor = ButterflyWinAnimator;


        ButterflyWinAnimator.prototype.initButterflyWinAnimator = function (supplyView) {
            BaseWinAnimator.call(this, supplyView);

            this._foggingBackground = null;
            this._pileView = null;
            /* PileView */
            this._glow = null;
            /* SpriteNode */
            this._animationState = AnimationStateEnum.None;
            /* AnimationStateEnum */

            this._numberOfCardsFallen = 0;
            /* int */
            this._numberOfCardsFinished = 0;
            /* int */
            this._totalNumberOfCards = 0;
            /* int */
            this._cardSpawnDelay = 0.0;
            /* float */
            this._glowStarted = false;
            /* bool */
            this._pilesCount = 0;
            /* int */
            this.CardSpawnNum = 0;

        };

        ButterflyWinAnimator.prototype.ShouldStartDuringCardMovement = function () /* bool */
        {
            return false;
        };

        ButterflyWinAnimator.prototype.BeginAnimation = function (/* Action */ endAnimationCallback, /* Card */ lastCardDropped, /* Pile */ lastPileDroppedOnto, /* bool */ dragging)
        {
            this._numberOfCardsFallen = 0;
            this._numberOfCardsFinished = 0;
            this._totalNumberOfCards = this.SupplyView.CardSupply.GetCardList().length;
            this._cardSpawnDelay = 0.21;

            this.assetLoader = new PIXI.AssetLoader([Absolute.Platform.artPathPrefix + '/' + Absolute.ScreenMetrics.getResClass() + '/butterfly.png'], false);
            this.assetLoader.addEventListener('onComplete', function() {
                var loader = new Absolute.Loader();
                loader.loadArt(['butterfly'], function () {}, function() {
                    this._animationState = AnimationStateEnum.Fogging;
                }.bind(this));
            }.bind(this));

            this.assetLoader.load();


            AudioManager.playSound('winButterfly');

            BaseWinAnimator.prototype.BeginAnimation.call(this, endAnimationCallback, lastCardDropped, lastPileDroppedOnto, dragging);
        };

        ButterflyWinAnimator.prototype.OnSizeChanged = function (/* object */ sender, /* WindowSizeChangedEventArgs */ e)
        {
            this.FinishEndingAnimation();
        };

        ButterflyWinAnimator.prototype.UpdateEndingAnimation = function (/* object */ o, /* EventArgs */  time)
        {
            if (this._hasUserClicked)
            {
                this.FinishEndingAnimation();
                return;
            }


            if (this._numberOfCardsFinished >= this._totalNumberOfCards)
            {
                this._animationState = AnimationStateEnum.Done;
            }

            if (this._animationState == AnimationStateEnum.Fogging)
            {
                this.SetFoggingBackground();
                if (this._foggingBackground.alpha < 0.6) {
                    this._foggingBackground.alpha += 0.01;
                }
                else  {
                    this._animationState = AnimationStateEnum.PilesGlow;
                }
            }

            if (this._animationState == AnimationStateEnum.PilesGlow)
            {
                if (!this._glowStarted)
                {
                    this.StartGlow();
                }

            }

            if (this._animationState == AnimationStateEnum.SpawnCards)
            {
                this._animationState = AnimationStateEnum.None;
                var cardA, cardB;
                var CardSpawnNum = this.CardSpawnNum;
                if (this.SupplyView.CardSupply.GetCardList().length > 52)
                {
                    if (CardSpawnNum % 4 == 0)
                    {
                        cardA = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation0").NthFromTop(Math.floor(1 + CardSpawnNum / 4)));
                        cardB = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation1").NthFromTop(Math.floor(1 + CardSpawnNum / 4)));
                    }
                    else if (CardSpawnNum % 4 == 1)
                    {
                        cardA = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation2").NthFromTop(Math.floor(1 + CardSpawnNum / 4)));
                        cardB = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation3").NthFromTop(Math.floor(1 + CardSpawnNum / 4)));
                    }
                    else if (CardSpawnNum % 4 == 2)
                    {
                        cardA = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation4").NthFromTop(Math.floor(1 + CardSpawnNum / 4)));
                        cardB = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation5").NthFromTop(Math.floor(1 + CardSpawnNum / 4)));
                    }
                    else
                    {
                        cardA = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation6").NthFromTop(Math.floor(1 + CardSpawnNum / 4)));
                        cardB = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation7").NthFromTop(Math.floor(1 + CardSpawnNum / 4)));
                    }
                }
                else
                {
                    if (CardSpawnNum % 2 == 0)
                    {
                        cardA = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation0").NthFromTop(Math.floor(1 + CardSpawnNum / 2)));
                        cardB = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation1").NthFromTop(Math.floor(1 + CardSpawnNum / 2)));
                    }
                    else
                    {
                        cardA = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation2").NthFromTop(Math.floor(1 + CardSpawnNum / 2)));
                        cardB = this.SupplyView.GetCardView(this.SupplyView.CardSupply.GetPile("Foundation3").NthFromTop(Math.floor(1 + CardSpawnNum / 2)));
                    }
                }
                this.CardSpawnNum++;
                if (cardA && cardB) {
                    var flyingCardNode = new FlyingCardNode(this, cardA, cardB);
                    this.AnimationContainer.AddChild(flyingCardNode);
                    flyingCardNode.TriggerSpawn();
                    cardA.Animating = true;
                    cardB.Animating = true;
                    //card.Visible = false;
                    this._numberOfCardsFallen += 2;
                }
                switch (this._numberOfCardsFallen)
                {
                    case 10:
                        this._cardSpawnDelay -= 0.01;
                        break;
                    case 25:
                        this._cardSpawnDelay -= 0.01;
                        break;
                }

                // Wait the prescribed amount of time before transitioning back into SpawnCards state to spawn the next card
                if (this._numberOfCardsFallen < this._totalNumberOfCards)
                {
                    Tween.Start(this.SupplyView).Wait(this._cardSpawnDelay).Then().Call(function () { this._animationState = AnimationStateEnum.SpawnCards; }.bind(this));
                }
            }
            if (this._animationState == AnimationStateEnum.Done)
            {
                this._animationState = AnimationStateEnum.None;
                Tween.Start(this.SupplyView.GameContainer).Wait(0.5).Then().Call(this.FinishEndingAnimation.bind(this));
            }
        };

        ButterflyWinAnimator.prototype.SetFoggingBackground = function()
        {
            if (this._foggingBackground == null)
            {
                this._foggingBackground = new PIXI.Graphics();
                this._foggingBackground.beginFill(0, 1);
                this._foggingBackground.drawRect(-0x2710, -0x2710, 0x4E20, 0x4E20);
                this._foggingBackground.endFill();
                this._foggingBackground.alpha = 0;
                this._background.addChild(this._foggingBackground);
            }
        };


        ButterflyWinAnimator.prototype.StartGlow = function ()
        {
            this._pilesCount = this.SupplyView.CardSupply.GetCardList().length > 52 ? 8 : 4;

            for (var i = 0; i < this._pilesCount; i++)
            {
                this._pileView = this.SupplyView.GetPileView("Foundation0");
                var scaleFactor = (this.SupplyView.GetCardView(this._pileView.Pile.NthFromTop(1)).ScaleX * 0.8);
                this._glow = new SpriteNode("fireworks-card-glow.png");
                this._glow.TextureAlphaEnabled = true;
                this._glow.Scale = new Vector2(scaleFactor, scaleFactor);
                this._glow.Visible = true;
                this._glow.Layer = 6;
                this._glow.Alpha = 0.0;


                var props = new Tween.TweenProperties();
                props.NumLoops = Tween.InfiniteLoops;

                this._pileView = this.SupplyView.GetPileView("Foundation" + i);
                Tween.Start(this._glow, props).FadeTo(0.5, 1.2).Then().FadeTo(0.1, 1.2);
                this._pileView.AddChildAt(this._glow, 0);
            }
            Tween.Start(this._pileView).Wait(1).Then().Call(function () { this._animationState = AnimationStateEnum.SpawnCards;}.bind(this));
            this._glowStarted = true;
        };

        ButterflyWinAnimator.prototype.FinishEndingAnimation = function ()
        {
            if (!this._hasAnimationStarted) return;

            AudioManager.stopSound('winButterfly');

            for (var i = 0; i < this._pilesCount; i++)
            {
                this._pileView = this.SupplyView.GetPileView("Foundation" + i);
                this._pileView.removeChildAt(0);
            }

            BaseWinAnimator.prototype.FinishEndingAnimation.call(this);
        };

        ButterflyWinAnimator.prototype.IsAnimationRunning = function () /* bool */
        {
            return this._hasAnimationStarted && !this._hasUserClicked &&  this._numberOfCardsFinished < this._totalNumberOfCards;
        };

        ButterflyWinAnimator.prototype.DidStartAnimation = function () /* bool */
        {
            return this._hasAnimationStarted;
        };

        ButterflyWinAnimator.prototype.ShouldShowEndingPopup = function () /* bool */
        {
            return this._hasAnimationStarted && (this._hasUserClicked || this._numberOfCardsFinished >= this._totalNumberOfCards);
        };

        ButterflyWinAnimator.prototype.StopAnimationPointEvent = function (/* PointEvent */ pointEvent)
        {
            this.DoClickEnding();
        };

        ButterflyWinAnimator.prototype.StopAnimationKeyEvent = function (/* KeyboardEvent */ keyboardEvent)
        {
            /*
             TODO
             if (keyboardEvent.Key == VirtualKey.Enter && keyboardEvent.Pressed)
             {
             DoClickEnding();
             }
             */
        };

        ButterflyWinAnimator.prototype.DoClickEnding = function ()
        {
            if (this._animationState == AnimationStateEnum.None)
            {
                this._hasUserClicked = true;
            }
        };

        ButterflyWinAnimator.prototype.IncrementNumberCardsFinished = function ()
        {
            this._numberOfCardsFinished += 2;
        };


        var FlyingCardNode = function (animator, leftCardView, rightCardView) {
            this.initFlyingCardNode(animator, leftCardView, rightCardView);
        };

        FlyingCardNode.contstuctor = FlyingCardNode;
        FlyingCardNode.prototype = Object.create(SpriteNode.prototype);

        FlyingCardNode.prototype.initFlyingCardNode = function (animator, leftCardView, rightCardView) {
            SpriteNode.call(this);

            this._cardAnimator = animator;
            this._leftCardView = leftCardView;
            this._rightCardView = rightCardView;

            this._cardView = new PIXI.DisplayObjectContainer();
            this.addChild(this._cardView);
            this.paused = false;
            this._cardNode = null;

            var emitterOptions = {
                    rate: { numpan: {a: 5, b: 8, center: true}, timepan: { a: 0.01, b: 0.02, center: null }},
                    mass: 1,
                    rotation: { a: [5,10,15,20,25,30,35,40,45], b: [0,3], style: 'add' },
                    velocity: 0.65,
                    alpha: { a: [0,1], b: 0 },
                    scale: { a: [0.2,0.02], b: 0, center: null},
                    gravity: 0,
                    life: {a: 1, b: 2, center: null},
                    radius: 1,
                    crossZone: null,
                    randomDrift: null
                },
                textures = [PIXI.Texture.fromFrame('Star.png'), PIXI.Texture.fromFrame('Star_orng_dot.png'), PIXI.Texture.fromFrame('Star_yellow_dot.png')];

            this.emitter = new ParticleEmitter(EngineManagers.UI, textures, emitterOptions, this._cardAnimator.AnimationContainer);

            EngineManagers.UI.stage[0].addChild(this.emitter);

            this.animation = new PIXI.Spine(Absolute.Platform.artPathPrefix + '/' + Absolute.ScreenMetrics.getResClass() + '/butterfly.json');

            this.animation.scale.set(0.9, 0.9);
            this.animation.state.setAnimationByName(0, 'fly_open_face_loop', true);

            var attachments = this.animation.skeleton.data.defaultSkin.attachments;

            function attachTexture (attachment, texture) {
                attachment.rendererObject.x = texture.frame.x;
                attachment.rendererObject.y = texture.frame.y;
                attachment.rendererObject.width = texture.frame.width;
                attachment.rendererObject.height = texture.frame.height;
                attachment.rendererObject.rotate = false;
                attachment.rendererObject.page.rendererObject = texture.baseTexture;
            }

            attachTexture(attachments['0:card1'], this._leftCardView.CardFront.sprite.texture);
            attachTexture(attachments['1:card1'], this._leftCardView.CardFront.sprite.texture);
            attachTexture(attachments['2:card2'], this._rightCardView.CardFront.sprite.texture);
            attachTexture(attachments['2:cardback'], this._leftCardView.CardBack.sprite.texture);

            this.animation.skeleton.slots[0].currentSprite = undefined;
            this.animation.skeleton.slots[0].currentSpriteName = undefined;
            this.animation.skeleton.slots[0].sprites = {};

            this.animation.skeleton.slots[1].currentSprite = undefined;
            this.animation.skeleton.slots[1].currentSpriteName = undefined;
            this.animation.skeleton.slots[1].sprites = {};

            this.animation.skeleton.slots[2].currentSprite = undefined;
            this.animation.skeleton.slots[2].currentSpriteName = undefined;
            this.animation.skeleton.slots[2].sprites = {};

            this._cardView.addChild(this.animation);
        };


        FlyingCardNode.prototype.PauseAnimation = function ()
        {
            this._paused = true;
        };

        FlyingCardNode.prototype.UpdateInternal = function (/* GameTime */ time)
        {
            if (!this._paused) { }

            if (this._cardNode != null && this.Visible) { }

            //this._glowNode.Alpha += time.ElapsedGameTime.Milliseconds * 0.001;
            SpriteNode.prototype.UpdateInternal.call(this, time);
        };

        FlyingCardNode.prototype.TriggerSpawn = function ()
        {

            this.position = this.toLocal(this._leftCardView.toGlobal(this._leftCardView.position));
            this.addChild(this._cardView);

            this._leftCardView.parent.removeChild(this._leftCardView);
            this._rightCardView.parent.removeChild(this._rightCardView);

            this.rand = new Random(0);
            this.numMoves = this.rand.Next(1, 4);

            this.emitter.start();
            this.flyTween();
        };

        FlyingCardNode.prototype.flyTween = function () {
            this.numMoves--;
            if (this.numMoves > 0) {
                this.nextX = this.rand.Next(0, EngineManagers.Display.Width);
                this.nextY = this.rand.Next(0, EngineManagers.Display.Height);
            }

            if (this.numMoves == 0) {
                if (this.nextX < EngineManagers.Display.Width / 2) {
                    this.nextX -= EngineManagers.Display.Width;
                }
                else {
                    this.nextX -= EngineManagers.Display.Width;
                }

                if (this.nextY < EngineManagers.Display.Height / 2) {
                    this.nextY -= EngineManagers.Display.Height;
                }
                else {
                    this.nextY -= EngineManagers.Display.Height;
                }
            }

            if (this.numMoves < 0) {
                this.visible = false;
                EngineManagers.UI.stage[0].removeChild(this.emitter);
                this.emitter.destroy();
                this._cardAnimator.IncrementNumberCardsFinished();
            }

            if (this.numMoves >= 0) {
                var self = this;
                var moveTween = new TWEEN.Tween({x: this.position.x, y: this.position.y, scale: this.scale.x})
                    .easing(TWEEN.Easing.Cubic.Out)
                    //.interpolation(TWEEN.Interpolation.Bezier)
                    .to({x: this.nextX, y: this.nextY, scale: 0.5}, 800)
                    .delay(500)
                    .onStart(function(){
                        self.animation.state.setAnimationByName(0, 'fly_angle_loop', true);
                    })
                    .onUpdate(function(){
                        self.position.x = this.x;
                        self.position.y = this.y;
                        self.emitter.x = self.x - self.width * 0.25;
                        self.emitter.y = self.y + self.height * 0.25;
                        self.scale.set(this.scale, this.scale);
                        //self.rotation = this.rotation;
                    })
                    .onComplete(function(){


                        self.flyTween();

                    });

                moveTween.start();
            }

        }

        return ButterflyWinAnimator;
    });

